import { createSlice } from "@reduxjs/toolkit";
import { GetRequisitionNames } from "services/dropdown/dropdown.service";
import { toast } from 'react-toastify';

export const requisitionNameSlice = createSlice({
  name: "requisitionNames",
  initialState: {
    requisitionNameList: [],
    requisitionNamesLoading: false,
    requisitionNamesError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetRequisitionNames.pending, (state) => {
      // toast.success('Promise Pending 🤯');
      state.requisitionNamesLoading = true
    });

    builder.addCase(GetRequisitionNames.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved 👌');
      state.requisitionNameList = action.payload
      state.requisitionNamesLoading = false
      state.requisitionNamesError = null
    });

    builder.addCase(GetRequisitionNames.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected 😣')

      state.requisitionNamesLoading = false
      state.requisitionNamesError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export default requisitionNameSlice.reducer;
